import{m as r}from"./memoize.js";var e=r;var a=function(r){var a=e(r,(function(r){return 500===n.size&&n.clear(),r})),n=a.cache;return a};export{a as _};
